<form [formGroup]="form">
  <div>
    <div class="dialog-content-container">
      <div class="procedure-section">
        <mat-spinner *ngIf="loading"></mat-spinner>

        <div *ngIf="!loading" style="margin-top: 20px">
          <mat-form-field class="procedureSelection">
            <input
              type="text"
              #procedureSel
              matInput
              placeholder="Práctica"
              formControlName="Procedure"
              [matAutocomplete]="procedureSelection"
            />
            <mat-autocomplete
              [displayWith]="displayPosiblePracticesFn"
              #procedureSelection="matAutocomplete"
            >
              <mat-option
                *ngFor="let procedure of filterCompletePosiblePractices | async"
                [value]="procedure"
              >
                {{ procedure.Name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <h4 *ngIf="noRecognizedProcedures.length > 0">
            Prácticas no reconocidas: {{ noRecognizedProcedures.length }}
          </h4>
          <div style="max-height: 100px; overflow-y: auto; overflow-x: auto">
            <ul
              *ngIf="noRecognizedProcedures.length > 0"
              style="
                list-style: none;
                padding: 10px;
                background-color: whitesmoke;
                border-radius: 8px;
                margin-top: 10px;
              "
            >
              <li
                *ngFor="let proc of noRecognizedProcedures"
                style="padding: 5px 0; font-size: 12px"
              >
                <span [style.color]="'red'">{{ proc.ExtractedProcedure }}</span>
              </li>
            </ul>
          </div>

          <h4 *ngIf="noAgreementProcedures.length > 0">
            Prácticas sín convenio: {{ noAgreementProcedures.length }}
          </h4>
          <div style="max-height: 100px; overflow-y: auto; overflow-x: auto">
            <ul
              *ngIf="noAgreementProcedures.length > 0"
              style="
                list-style: none;
                padding: 10px;
                background-color: whitesmoke;
                border-radius: 8px;
                margin-top: 10px;
              "
            >
              <li
                *ngFor="let proc of noAgreementProcedures"
                style="padding: 5px 0; font-size: 12px"
              >
                <span [style.color]="'red'">{{
                  proc.PracticeRegion.Name
                }}</span>
              </li>
            </ul>
          </div>

          <h4 *ngIf="recognizedProcedures.length > 0">
            Prácticas reconocidas: {{ recognizedProcedures.length }}
          </h4>
          <div
            *ngIf="recognizedProcedures.length > 0"
            style="max-height: 300px; overflow-y: auto; overflow-x: auto"
          >
            <mat-table [dataSource]="dataSource">
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                  >
                  </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                  >
                  </mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Extracted Procedure Column -->
              <!-- <ng-container matColumnDef="extracted">
              <mat-header-cell *matHeaderCellDef class="left-align-cell">
                Práctica
              </mat-header-cell>
              <mat-cell *matCellDef="let proc" class="left-align-cell">
                <span [style.color]="proc.PracticeRegion ? 'green' : 'red'">
                  {{ proc.PracticeRegion.Name }}
                  <br />
                  <small class="sub-text">
                    {{ proc.ExtractedProcedure }}
                  </small>
                </span>
              </mat-cell>
            </ng-container> -->

              <ng-container matColumnDef="extracted">
                <mat-header-cell *matHeaderCellDef class="left-align-cell">
                  Práctica
                </mat-header-cell>
                <mat-cell *matCellDef="let proc" class="left-align-cell">
                  <div>
                    <span [style.color]="proc.PracticeRegion ? 'green' : 'red'">
                      {{ proc.PracticeRegion.Name }}
                    </span>

                    <button mat-icon-button (click)="toggleRow(proc)">
                      <mat-icon>
                        {{
                          expandedRows.has(proc) ? "expand_less" : "expand_more"
                        }}
                      </mat-icon>
                    </button>

                    <div *ngIf="expandedRows.has(proc)">
                      <small class="sub-text">
                        {{ proc.ExtractedProcedure }}
                      </small>
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Header and Row Declarations -->
              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></mat-row>
            </mat-table>
          </div>
        </div>
      </div>

      <div
        class="preview-section-pdf"
        *ngIf="info && info.fileBase64 && isPdf()"
      >
        <iframe
          [src]="sanitizedFileUrl"
          type="application/pdf"
          width="100%"
          height="100%"
          style="border: none"
        ></iframe>
      </div>
      <div class="preview-section" *ngIf="info && info.fileBase64 && !isPdf()">
        <div class="preview-toolbar">
          <button mat-mini-button (click)="zoomIn()">+</button>
          <button mat-mini-button (click)="zoomOut()">−</button>
          <button mat-mini-button (click)="resetZoom()">100%</button>
          <!-- botón de rotar eliminado -->
        </div>

        <div
          class="preview-scrollable-content"
          (mousedown)="startDragging($event)"
          (mousemove)="onDrag($event)"
          (mouseup)="stopDragging()"
          (mouseleave)="stopDragging()"
          (wheel)="onWheel($event)"
          [style.cursor]="isDragging ? 'grabbing' : 'grab'"
        >
          <img
            [src]="sanitizedFileUrl"
            alt="Preview"
            class="zoomable-image"
            [ngStyle]="{
              transform:
                'scale(' +
                zoomLevel +
                ') translate(' +
                translateX +
                'px, ' +
                translateY +
                'px)',
              transformOrigin: 'center center'
            }"
          />
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!loading" class="dialog-footer sticky-footer">
    <button
      *ngIf="selection.hasValue()"
      mat-button
      type="button"
      cdkFocusInitial
      (click)="finish()"
    >
      Aplicar
    </button>

    <button mat-button type="button" (click)="process()">Reprocesar</button>

    <button mat-button type="button" (click)="onNoClick($event)">Salir</button>
  </div>
</form>
